import React from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import StudentChurnGauge from './StudentChurnGauge';
import { StudentChurnListService } from '../../services/CustomerSuccessKpiListService';
import CustomerSuccessHistoryService from '../../services/CustomerSuccessHistoryService';

class StudentChurnGaugeContainer extends React.Component {
  constructor(props) {
    super(props);
    StudentChurnListService.load();
  }

  render() {
    return (
      <StudentChurnGauge
        loading={StudentChurnListService.fetchCurrent.fetching || StudentChurnListService.fetchPrevious.fetching}
        currentValue={toJS(StudentChurnListService.global.current)}
        previousValue={toJS(StudentChurnListService.global.previous)}
        onClickHistory={() => CustomerSuccessHistoryService.openDialog('STUDENT_CHURN')}
        formatter={StudentChurnListService.getFormattedValue}
      />
    );
  }
}

export default observer(StudentChurnGaugeContainer);
